const ErrorCodes = class ErrorCodes {
  static get API_ERROR_CODES() {
    return {
      delete_set_annotation_error: 'building.deleteSetAnnotationError',
      annotation_not_exists: 'translation.deletedAnnotationNotice',
      invalid_building_status_for_session:
        'building.invalidBuildingStatusForSession',
      building_not_taking_picture: 'building.buildingNotTakingPicture',
      floor_migrate_in_progress_error: 'building.floorMigrateInProgress',
      invalid_image_aspect_ratio: 'building.invalidImageAspectRatio'
    }
  }

  static get VALIDATION_ERROR_CODES() {
    return {
      // forgot-password
      A11002: ['email'], // Email not exist,
      username_exists: ['email'],
      code_is_unique: ['code'],
      email_domain_unique: ['emailDomain'],
      email_not_exists: ['email']
    }
  }
}

export default ErrorCodes
